import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { produce } from 'immer'
import { reverse } from 'lodash'
import useSnackbar from 'common/use-snackbar'

import useLoadUploads from './use-load-uploads'

export const ReportContext = React.createContext()

const ReportContextProvider = ({ children }) => {
  const [uploads, setUploads] = useState([])
  const [columnMappingData, setColumnMappingData] = useState()
  const uploadError = useSnackbar('An error occured while retrieving uploads...')
  const addItem = useCallback(
    (item) => {
      setUploads(
        produce(uploads, (draft) => {
          draft.unshift(item)
        }),
      )
    },
    [uploads],
  )
  const onLoad = useCallback(({ uploads }) => {
    setUploads(reverse(uploads))
  }, [])
  const onError = useCallback(uploadError, [uploadError])
  useLoadUploads(onLoad, onError)
  return (
    <ReportContext.Provider
      value={{
        uploads,
        columnMappingData,
        onAddFile: (item) => addItem(item),
        onSetColumnMappingData: (data) => setColumnMappingData(data),
      }}
    >
      {children}
    </ReportContext.Provider>
  )
}
ReportContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
}

export default ReportContextProvider
